// extracted by mini-css-extract-plugin
module.exports = {"editable":"plagiarism_editable__3njvP","editabletwo":"plagiarism_editabletwo__3-s2M","btn_trns":"plagiarism_btn_trns__3xCF0"};